//#region Dependencias
import React, {Component} from 'react';
import {BreadCumb, DataTables, InventoryCountingCreateModal, NavBar,TimeOut} from "../../components";
import config from "../../config";
import moment from "moment";
import {DISPATCH_ID, SERVICE_RESPONSE} from "../../libs/utils/Const";
import {ApiClient} from "../../libs/apiClient";
import {connect} from "react-redux";
import $ from "jquery";
import { InventoryPosting, InventoryPostingLine } from '../../components/NewOrder';
//#endregion

//#region Variables globales
const apiClient = ApiClient.getInstance();
const statusFormat = (status) => { switch (status) { case 'O': return 'Abierto'; case 'C': return 'Cerrado'; default: return 'Pendiente'; } }
const dateFormat = (date) => { return moment(date).format("YYYY-MM-DD"); }
const timeFormat = (time) => { return Number(time) > 999 ? `${time.toString().substring(0, 2)}:${time.toString().substring(2)}` : `0${time.toString().substring(0, 1)}:${time.toString().substring(1)}`; }
const headersDataTable = [
    { title: "Serie", value: true, field: "Series", format: null, classes: "text-left" },
    { title: "N° Doc", value: true, field: "DocNum", format: null, classes: "text-left" },
    { title: "Estatus", value: true, field: "Status", format: statusFormat, classes: "text-center" },
    { title: "Fecha", value: true, field: "CountDate", format: dateFormat, classes: "text-right" },
    { title: "Hora", value: true, field: "CountTime", format: timeFormat, classes: "text-right" },
    { title: "Referencia", value: true, field: "Reference2", format: null, classes: "text-left" },
    { title: "Comentarios", value: true, field: "Comments", format: null, classes: "text-left" },
];
//#endregion

//#region Componente
class InventoryPostingView extends Component {
    //#region Acciones del componente
    constructor(props) {
        super(props)
        this.state = {
            view: "inventoryPosting",
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + "currentUser")),
            inventoryPostingModel: new InventoryPosting(),
            priceListArray: [],
            action: 1,
        }
    }

    async componentDidMount() {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liReturnRequest");
        let today = moment(new Date()).format("YYYYMMDD");

        let date = {
            dateInit: today,
            dateFinal: today,
        }
        await this.callDocumentsListService(date);
        await this.getDataLists();
    }
    //#endregion

    //#region Consultar Información
    callDocumentsListService = async (filters) => {
        const {notificationReducer:  { showAlert }, enableSpinner } = this.props;

        // Filtros de búsqueda de los documentos
        let data = {
            table: "OIQR",
            filters: {
                dateInit: filters.dateInit || moment().format("YYYY-MM-DD"),
                dateEnd: filters.dateFinal || moment().format("YYYY-MM-DD"),
                status: filters.docStatus || '---',
                series: filters.searchSerieName || '--',
                docNum: filters.docNumSearch || '--',
            }
        };

        enableSpinner(true);
        let returnListResponse = await apiClient.inventoryDocumentsList(data);
        enableSpinner(false);

        if(returnListResponse.status === SERVICE_RESPONSE.SUCCESS){
            returnListResponse = returnListResponse.data || [];
            // let dataSerie = { docType: "10000071", docSubType: "--" };

            // enableSpinner(true);
            // let seriesResponse = await apiClient.getSeries(dataSerie);
            // seriesResponse = seriesResponse.data || [];
            // enableSpinner(false);

            // let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

            // let ValidateSeries = user.U_FMB_ValidateSeriesOIQR ? user.U_FMB_ValidateSeriesOIQR : "";

            // if (!user || !ValidateSeries || ValidateSeries === "") {
            //     this.setState({ data: [] });
            //     return showAlert({ type: 'warning', message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador",  timeOut: 5000 });
            // }

            // let seriesUsers = ValidateSeries.split("|") || [];

            // let newArraySeries = seriesUsers?.filter(SeriesUser => seriesResponse.some(({Series}) => Number(SeriesUser) === Number(Series))) || [];

            // if (newArraySeries.length === 0) { return showAlert({ type: 'warning', message: "El usuario no tiene serie permitida de escritura y lectura", timeOut: 5000 }); }

            // let newDocumentsfilterSeries = returnListResponse.filter(({SeriesCode}) => newArraySeries.some(Series => Number(SeriesCode) === Number(Series))) || [];

            // if(( params.docNumSearch && params.docNumSearch !== '--' ) || ( params.searchSerieName !== '--' && params.searchSerieName )){ newDocumentsfilterSeries = returnListResponse || []; }

            // if (newDocumentsfilterSeries.length === 0) {
            //     this.setState({ data: [] });
            //     return showAlert({ type: 'info', message: "No se encontraron resultados correspondientes a la búsqueda.", timeOut: 5000 });
            // }
            
            this.setState({ data: returnListResponse });
            return;
        } else {
            this.setState({ data: [] });
            return showAlert({ type: 'info', message: "No se encontraron resultados correspondientes a la búsqueda.", timeOut: 5000 });
        }
    };

    openDocumentDetails = async (docEntry, modalActive = false) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        const data = {
            table: "OIQR",
            docEntry,
        };

        enableSpinner(true);
        const detailsResponse = await apiClient.inventoryDocumentDetails(data);
        enableSpinner(false);

        if (detailsResponse.status === SERVICE_RESPONSE.SUCCESS) {
            const header = detailsResponse.data.header;
            const lines = detailsResponse.data.items;

            let inventoryPostingModel = new InventoryPosting();
            
            inventoryPostingModel.DocumentEntry = docEntry;
            inventoryPostingModel.DocumentNumber = header.DocNum || '';
            inventoryPostingModel.Series = header.Series || '';
            inventoryPostingModel.SeriesName = header.SeriesName || '';
            inventoryPostingModel.PostingDate = header.DocDate || '';
            inventoryPostingModel.CountDate = dateFormat(header.CountDate || new Date());
            inventoryPostingModel.CountTime = timeFormat(header.CountTime || 1200);
            inventoryPostingModel.Remarks = header.Comments || '';
            inventoryPostingModel.Reference2 = header.Reference2 || '';
            inventoryPostingModel.PriceSource = header.PriceSrc || '2';
            inventoryPostingModel.PriceList = header.PriceList || '-1';
            inventoryPostingModel.JournalRemark = header.JrnlMemo || '';

            let newLines = [];

            if (Array.isArray(lines)) {
                for (let i = 0; i < lines.length; i++) {
                    const currentLine = lines[i];
                    let newLine = new InventoryPostingLine();
    
                    newLine.DocumentEntry = docEntry;
                    newLine.LineNumber = currentLine.LineNum || 0;
                    newLine.ItemCode = currentLine.ItemCode || '';
                    newLine.ItemDescription = currentLine.Dscription || '';
                    newLine.WarehouseCode = currentLine.WhsCode || '';
                    newLine.InWarehouseQuantity = Number(currentLine.OnHandBef || 0).toFixed(3);
                    newLine.Variance = Number(currentLine.Difference || 0).toFixed(3);
                    newLine.VariancePercentage = Number(currentLine.DiffPercnt || 0).toFixed(4);
                    newLine.CountedQuantity = Number(currentLine.CountQty || 0).toFixed(3);
                    newLine.Price = Number(currentLine.Price || 0).toFixed(2);
                    newLine.Total = Number(currentLine.DocTotal || 0).toFixed(2);
                    newLine.BaseEntry = currentLine.BaseEntry || -1;
                    newLine.BaseLine = currentLine.BaseLine || -1;
                    newLine.BaseType = currentLine.BaseType || -1;
                    newLine.Remarks = currentLine.Remark || "";
    
                    newLines.push(newLine);
                }
            }

            inventoryPostingModel.InventoryPostingLines = newLines;

            await this.setState({inventoryPostingModel, action: 2});

            if (!modalActive) {
                await this.setState({ showCreateModal: true });
                $("#InventoryCountingCreateModal").modal("show");
                $("#InventoryCountingCreateModal").on("hidden.bs.modal", async () => {
                    await this.setState({ showCreateModal: false });
                });
            }
            return;
        }

        showAlert({ type: 'error', message: detailsResponse.message });
    }

    getDataLists = async () => {
        const { enableSpinner } = this.props;

        let priceListArray = [];
        enableSpinner(true);
        priceListArray = await apiClient.getPriceList();
        priceListArray = Array.isArray(priceListArray?.data) ? priceListArray.data : [];
        enableSpinner(false);

        await this.setState({ priceListArray });
    }
    //#endregion

    //#region Crear nuevo documento
    createDocument = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { inventoryPostingModel } = this.state;

        try {
            enableSpinner(true);

            let data = {
                table: "OIQR",
                model: inventoryPostingModel,
            };
    
            let responseArray = [];    
            let response = await apiClient.createInventoryDocument(data);
    
            try {
                responseArray.push({
                    billing: response?.data?.docNumBilling || '',
                    docNum: response?.data?.DocNum || '',
                    message: response?.message || '',
                });
            } catch (e) {
                responseArray.push({
                    docNum: '',
                    billing: '',
                    message: '',
                });
            }

            this.setState({ billingResponseArray: responseArray })

            $("#billingResponseModal").modal("show");
            $("#billingResponseModal").on("hidden.bs.modal", () => { this.setState({ billingResponseArray: null }) });

            if (response.status === 1) { $('#InventoryCountingCreateModal').modal('hide'); }
            enableSpinner(false);
        } catch (e) {
            showAlert({ type: "error", message: JSON.stringify(e) });
            enableSpinner(false);
        }
    }

    createNewDocumentModel = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let inventoryPostingModel = new InventoryPosting();
        
        let dataSerie = {
            docType: inventoryPostingModel.ObjectType,
            docSubType: '--'
        };

        enableSpinner(true);
        let seriesResponse = await apiClient.getSeries(dataSerie);
        enableSpinner(false);

        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        let ValidateSeries = Array.isArray(seriesResponse?.data)? (seriesResponse.data.filter(({ ObjectCode }) => ObjectCode === inventoryPostingModel.ObjectType)) : [];
        let seriesUsers = user?.U_FMB_ValidateSeriesOIQR;

        if (!user || !ValidateSeries.length || !seriesUsers) {
            return showAlert({ type: 'warning', message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador", timeOut: 5000 });
        }

        seriesUsers = seriesUsers.split("|");

        let newArraySeries = [];

        for (let index = 0; index < seriesUsers.length; index++) {
            const serieUser = seriesUsers[index];
            for (let index = 0; index < ValidateSeries.length; index++) {
                const serieResponse = ValidateSeries[index];
                if (serieResponse.Series.toString() === serieUser.toString()) {
                    newArraySeries.push(serieResponse);
                }
            }
        }

        if (newArraySeries.length === 0) {
            return showAlert({ type: 'warning', timeOut: 5000, message: "El usuario no tiene serie permitida de escritura" });
        }

        let defaultName = "";
        let defaultcode = "";
        let nextNumber = "";

        for (let index = 0; index < newArraySeries.length; index++) {
            const serie = newArraySeries[index];
            if (serie.Series.toString() === newArraySeries[0].DfltSeries.toString()) {
                defaultName = serie.SeriesName;
                defaultcode = serie.Series;
                nextNumber = serie.NextNumber
            }
        }

        inventoryPostingModel.SerieArray = newArraySeries || [];
        inventoryPostingModel.Series = defaultcode;
        inventoryPostingModel.SeriesName = defaultName;
        inventoryPostingModel.DocumentNumber = nextNumber;
        inventoryPostingModel.PostingDate = dateFormat(new Date());
        inventoryPostingModel.CountDate = dateFormat(new Date());
        inventoryPostingModel.CountTime = timeFormat(moment(new Date()).format("HHmm"));

        await this.setState({ showCreateModal: true, inventoryPostingModel, action: 1});
        $("#InventoryCountingCreateModal").modal("show");
        $("#InventoryCountingCreateModal").on("hidden.bs.modal", async () => {
            await this.setState({ showCreateModal: false });
        });
    }

    updateModel = async (inventoryPostingModel) => {
        await this.setState({inventoryPostingModel});
    }
    //#endregion

    //#region Render
    render() {
        const {
            view,
            headers,
            data,
            _user,
            inventoryPostingModel,
            action,
            priceListArray,
            billingResponseArray,
            showCreateModal,
        } = this.state;

        const { enableSpinner, notificationReducer: {showAlert} } = this.props;

        const actions = {
            openDocumentDetails: this.openDocumentDetails,
            createDocument: this.createNewDocumentModel,
        }
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user}/>
                <TimeOut/>
                <BreadCumb subitem1={'CONTABILIZACIÓN DE STOCKS'} url1={'#'}/>
                <div style={{marginLeft: "4rem", marginBottom: "12rem"}}>
                    <h2 className="md-display-1 text-muted"> &nbsp; CONTABILIZACIÓN DE STOCKS </h2>
                    {showCreateModal &&
                        <InventoryCountingCreateModal
                            _user={_user}
                            view={view}
                            createDocument={this.createDocument}
                            model={inventoryPostingModel}
                            updateModel={this.updateModel}
                            action={action}
                            itemsList={[]}
                            usersList={[]}
                            employeesList={[]}
                            locationsList={[]}
                            priceListArray={priceListArray}

                            enableSpinner={enableSpinner}
                            showAlert={showAlert}/>
                    }
                    <DataTables
                        headers={headers}
                        view={view}
                        data={data}
                        search={this.callDocumentsListService}
                        actions={actions}
                        billingResponse={billingResponseArray}/>
                </div>
            </div>
        );
    }
    //#endregion
}
//#endregion

//#region REDUX
const mapStateToProps = store => {
    return {notificationReducer: store.NotificationReducer};
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value})
    };
};
//#endregion

export default connect( mapStateToProps, mapDispatchToProps )(InventoryPostingView); // Exportar componente